export const uwUnassignedFilterInitialValues = {
	age_in_underwriting: null,
	number: "",
	merchantName: "",
	processor: null,
	sponsor: null,
	agentOffice: null,
	agent: null,
	mccCode: "",
	highRisk: "",
};

export const uwInReviewFilterInitialValues = {
	age_in_underwriting: null,
};

export const uwPendedFilterInitialValues = {
	age_in_underwriting: null,
	age_of_pend: null,
	agent: null,
	agentOffice: null,
	assigned_to: null,
	highRisk: null,
	mccCode: "",
	merchantName: "",
	number: "",
	pendReason: null,
	pendStatus: null,
	pendedTo: null,
	processor: null,
	sponsor: null,
};

export const uwHistoricalFilterInitialValues = {
	age_in_underwriting: null,
};

export const uwConcurrenceConditionsFilterInitialValues = {
	age_in_underwriting: null,
	age_in_approved: null,
};

export const uwQaUnassignedFilterInitialValues = {
	age_in_underwriting: null,
};

export const uwQaInProgressFilterInitialValues = {
	age_in_underwriting: null,
};

export const uwQaCompletedFilterInitialValues = {
	age_in_underwriting: null,
};

export const uwStrictResetEmptyFilterValues = [
	"age_in_underwriting",
	"age_in_approved",
	"age_of_pend",
];
